export const paths = []


// WEBPACK FOOTER //
// ./src/views/User/Afilliation/routers.js